import {Component} from '@angular/core';

@Component({
  selector: 'admin-right-nav',
  templateUrl: './right-nav.component.html',
  styleUrls: ['./right-nav.component.scss']
})
export class RightNavComponent {

}
